// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"ecf6be59","453":"2a008f1e"}[chunkId] + ".chunk.js";
};